var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgApple = function SvgApple(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17191C",
    fillRule: "evenodd",
    d: "M16.98 1.28a4.87 4.87 0 0 1-1.114 3.49 4.1 4.1 0 0 1-3.237 1.53 4.64 4.64 0 0 1 1.144-3.36 4.96 4.96 0 0 1 3.207-1.66m3.974 7.428a4.95 4.95 0 0 0-2.357 4.152 4.78 4.78 0 0 0 2.92 4.4 11 11 0 0 1-1.519 3.092c-.894 1.338-1.832 2.645-3.32 2.669-.708.016-1.186-.187-1.684-.4-.52-.22-1.06-.451-1.907-.451-.899 0-1.464.238-2.01.467-.47.198-.927.39-1.57.417-1.417.053-2.5-1.428-3.427-2.753-1.853-2.707-3.296-7.628-1.362-10.976a5.32 5.32 0 0 1 4.473-2.728c.804-.017 1.576.293 2.252.565.517.208.979.393 1.357.393.332 0 .78-.178 1.304-.386.824-.326 1.832-.727 2.859-.619 1.596.05 3.075.85 3.99 2.158",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApple);
export { ForwardRef as Icon };
export default "img/element-icons/brands/apple.734de1e.svg";